import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import "./Value.css";

function Value({
  id,
  title,
  titleEnglish,
  description,
  descriptionEnglish,
  handleShow,
  language,
}) {
  const { t } = useTranslation();

  return (
    <Row className="value align-items-center">
      <Col lg={11} className="value-header">
        <h5>{language === "en" ? titleEnglish : title}</h5>
        <p>{language === "en" ? descriptionEnglish : description}</p>
      </Col>
      <Col lg={1} className="value-content">
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
            <FontAwesomeIcon icon={faCog} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item as={Link} to={`/values/edit/${id}`}>
              <FontAwesomeIcon icon={faEdit} />{" "}
              {t("Reconocimientos.Valores.Valor.Editar")}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleShow(id)}>
              <FontAwesomeIcon icon={faTrash} />{" "}
              {t("Reconocimientos.Valores.Valor.Eliminar")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
}

export default Value;
